// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1KroB","title":"BackImages_title__1nIce","images":"BackImages_images__2S24O"};